interface Iprops {
  width: number;
  height: number;
}

export const CalendarIcon = ({ width, height }: Iprops) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none">
      <path
        d="M8 5.75C7.59 5.75 7.25 5.41 7.25 5V2C7.25 1.59 7.59 1.25 8 1.25C8.41 1.25 8.75 1.59 8.75 2V5C8.75 5.41 8.41 5.75 8 5.75Z"
        fill="#7B7B7B"
      />
      <path
        d="M16 5.75C15.59 5.75 15.25 5.41 15.25 5V2C15.25 1.59 15.59 1.25 16 1.25C16.41 1.25 16.75 1.59 16.75 2V5C16.75 5.41 16.41 5.75 16 5.75Z"
        fill="#7B7B7B"
      />
      <path
        d="M20.5 9.83997H3.5C3.09 9.83997 2.75 9.49997 2.75 9.08997C2.75 8.67997 3.09 8.33997 3.5 8.33997H20.5C20.91 8.33997 21.25 8.67997 21.25 9.08997C21.25 9.49997 20.91 9.83997 20.5 9.83997Z"
        fill="#7B7B7B"
      />
      <path
        d="M16 22.75H8C4.35 22.75 2.25 20.65 2.25 17V8.5C2.25 4.85 4.35 2.75 8 2.75H16C19.65 2.75 21.75 4.85 21.75 8.5V17C21.75 20.65 19.65 22.75 16 22.75ZM8 4.25C5.14 4.25 3.75 5.64 3.75 8.5V17C3.75 19.86 5.14 21.25 8 21.25H16C18.86 21.25 20.25 19.86 20.25 17V8.5C20.25 5.64 18.86 4.25 16 4.25H8Z"
        fill="#7B7B7B"
      />
      <path
        d="M7.5 13.5056C7.5 12.9533 7.94772 12.5056 8.5 12.5056C9.05228 12.5056 9.5 12.9533 9.5 13.5056C9.5 14.0578 9.05228 14.5056 8.5 14.5056C7.94772 14.5056 7.5 14.0578 7.5 13.5056Z"
        fill="#7B7B7B"
      />
      <path
        d="M11 13.5056C11 12.9533 11.4477 12.5056 12 12.5056C12.5523 12.5056 13 12.9533 13 13.5056C13 14.0578 12.5523 14.5056 12 14.5056C11.4477 14.5056 11 14.0578 11 13.5056Z"
        fill="#7B7B7B"
      />
      <path
        d="M14.5 13.5056C14.5 12.9533 14.9477 12.5056 15.5 12.5056C16.0523 12.5056 16.5 12.9533 16.5 13.5056C16.5 14.0578 16.0523 14.5056 15.5 14.5056C14.9477 14.5056 14.5 14.0578 14.5 13.5056Z"
        fill="#7B7B7B"
      />
      <path
        d="M7.5 17.0125C7.5 16.4602 7.94772 16.0125 8.5 16.0125C9.05228 16.0125 9.5 16.4602 9.5 17.0125C9.5 17.5648 9.05228 18.0125 8.5 18.0125C7.94772 18.0125 7.5 17.5648 7.5 17.0125Z"
        fill="#7B7B7B"
      />
      <path
        d="M11 17.0125C11 16.4602 11.4477 16.0125 12 16.0125C12.5523 16.0125 13 16.4602 13 17.0125C13 17.5648 12.5523 18.0125 12 18.0125C11.4477 18.0125 11 17.5648 11 17.0125Z"
        fill="#7B7B7B"
      />
      <path
        d="M14.5 17.0125C14.5 16.4602 14.9477 16.0125 15.5 16.0125C16.0523 16.0125 16.5 16.4602 16.5 17.0125C16.5 17.5648 16.0523 18.0125 15.5 18.0125C14.9477 18.0125 14.5 17.5648 14.5 17.0125Z"
        fill="#7B7B7B"
      />
    </svg>
  );
};
